import DomainResource from './DomainResource';
import CodeableConcept from './types/CodeableConcept';
import Identifier from './types/Identifier';
import MeasurementSource from './MeasurementSource';
import Reference from './types/Reference';
import Timing from './types/Timing';
import merge from 'lodash/merge';
import { contactPointTraits } from './trait/contactPointTraits';
import Period from '@/fhirworks/types/Period';
import CarePlanActivity from '@/fhirworks/CarePlanActivity';
import CarePlanTarget from '@/fhirworks/CarePlanTarget';
import Annotation from '@/fhirworks/types/Annotation';

export default class CarePlan extends DomainResource {
    static __className = 'CarePlan';

    __objectStructure = {
        identifier: [Identifier], // External Ids for this item
        basedOn: [Reference], // Fulfills CarePlan
        replaces: [Reference], // CarePlay replaced by this CarePlan
        partOf: [Reference], // Part of referenced CarePlan
        status: String, // *required* draft | active | on-hold | revoked | completed | entered-in-error | unknown
        intent: String, // *required* proposal | plan | order | option
        category: [CodeableConcept], // Type of plan
        title: String, // Human-friendly name for the CarePlan
        description: String, // Summary of nature of plan
        subject: Reference, // Time period team covers
        encounter: Reference, // Encounter created as part of
        period: Period, // Time period plan covers
        created: String, // Date record was first recorded
        author: Reference, // Who is the designated responsible party
        contributor: [Reference], // Who provided the content of the care plan
        goal: [Reference], // Desired outcome of plan
        activity: [CarePlanActivity], // Action to occur as part of plan

        // first-class extensions
        estEndDate: String,
        libraryId: String,
        order: Number,
        reviewNote: [Annotation], // Comments about the CarePlan, specifically from a review
        finalizedInForm: String, // Stores which form the item's status became either 'entered-in-error' or 'completed'
        measurementTiming: Timing, // Measurability: frequency, qualitative duration
        measurementSource: [MeasurementSource], // Measurability: source methodology
        target: [CarePlanTarget], // Measurability: amount criterion (mirrors Goal.target shape)
    };

    constructor(constructJson, className = 'CarePlan') {
        super(constructJson, className);

        contactPointTraits.call(this);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
